import { AHText, TextTypes } from "arkh";
import React, { useRef } from "react";
import { FormattedMessage } from "react-intl";

const emojis = ["🏄‍♂️", "🥳", "🕺", "🎉"];

export function TodoResolvedBy(props: { name: string; type?: TextTypes }) {
  const num = useRef(Math.floor(Math.random() * 3));
  return (
    <AHText type={props.type ?? "detail"} color="positive">
      <FormattedMessage
        description="TodoListItemResolvedBy"
        defaultMessage="Great job {name} {emoji}"
        values={{ name: props.name, emoji: emojis[num.current] }}
      />
    </AHText>
  );
}
